export default __webpack_public_path__ + "static/media/188.c485c9c1.svg";